import { render, staticRenderFns } from "./TaxSubsidiesApply.vue?vue&type=template&id=a4f6e266&scoped=true&"
import script from "./TaxSubsidiesApply.vue?vue&type=script&lang=js&"
export * from "./TaxSubsidiesApply.vue?vue&type=script&lang=js&"
import style0 from "./TaxSubsidiesApply.vue?vue&type=style&index=0&id=a4f6e266&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f6e266",
  null
  
)

export default component.exports